import { queryKeysBuilder } from '@/api/queries.utils';

const builder = queryKeysBuilder(['beneficiaries']);

export const beneficiariesQueryKeys = {
  all: builder(),
  count: builder('count'),
  one: (id: number) => builder('one', id),
};
